"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIBlockListSchema = exports.BlockListSchema = exports.AnyOpenAIBlockSchema = exports.AnyBlockSchema = exports.CustomBlock = exports.BlockEventSchema = exports.BlockActionSchema = exports.BlockSelectSchema = exports.BlockTextSchema = exports.BlockSectionSchema = exports.BlockUnknownSchema = void 0;
const zod_1 = require("zod");
const element_1 = require("../element");
const attachment_1 = require("../attachment");
const visualization_1 = require("../visualization");
const openai_1 = require("../openai");
exports.BlockUnknownSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('unknown'),
})
    .openapi('UnknownBlock');
exports.BlockSectionSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('section'),
    text: zod_1.z.string().nullable(),
    fields: zod_1.z.array(zod_1.z.object({
        label: zod_1.z.string(),
        value: zod_1.z.string(),
    })),
}, { description: 'a section includes set of fields for previewing structured data' })
    .openapi('SectionBlock');
exports.BlockTextSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('text'),
    text: zod_1.z.string(),
    attachments: zod_1.z
        .array(attachment_1.AttachmentObjectSchema, { description: 'a list of attachments' })
        .nullable(),
    modifiers: zod_1.z
        .array(zod_1.z.enum(['bold', 'italic', 'code', 'strikethrough']))
        .nullable(),
}, { description: 'a text block schema' })
    .openapi('TextBlock');
exports.BlockSelectSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('input'),
    type: zod_1.z.literal('select'),
    placeholder: zod_1.z.string().nullable(),
    options: zod_1.z.array(zod_1.z.object({
        label: zod_1.z.string(),
        value: zod_1.z.string(),
    })),
}, { description: 'a select input block schema' })
    .openapi('SelectBlock');
exports.BlockActionSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('action'),
    elements: zod_1.z.array(element_1.AnyElementSchema),
}, { description: 'an action block schema' })
    .openapi('ActionBlock');
exports.BlockEventSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('event'),
    data: zod_1.z.discriminatedUnion('kind', [
        zod_1.z.object({
            kind: zod_1.z.literal('action'),
            id: zod_1.z.string(),
        }),
    ]),
}, { description: 'an event block schema' })
    .openapi('EventBlock');
exports.CustomBlock = zod_1.z
    .object({
    kind: zod_1.z.literal('custom'),
    custom: zod_1.z.discriminatedUnion('type', [visualization_1.VisualizationBlockDataSchema]),
})
    .openapi('CustomBlock');
// export const CustomBlock = z
//     .object({
//         kind: z.literal('custom'),
//         type: z.string(),
//         data: z.record(z.string(), z.any()),
//     })
//     .openapi('CustomBlock');
exports.AnyBlockSchema = zod_1.z
    .discriminatedUnion('kind', [
    exports.BlockUnknownSchema,
    exports.BlockSelectSchema,
    exports.BlockTextSchema,
    exports.BlockSectionSchema,
    exports.BlockActionSchema,
    exports.BlockEventSchema,
    exports.CustomBlock,
], { description: 'a block schema' })
    .openapi('Block');
exports.AnyOpenAIBlockSchema = zod_1.z.discriminatedUnion('kind', [
    exports.BlockUnknownSchema,
    exports.BlockSelectSchema,
    exports.BlockTextSchema,
    exports.BlockSectionSchema,
    exports.BlockActionSchema,
    exports.BlockEventSchema,
    openai_1.OpenAIVisualizationBlockSchema,
], { description: 'a block schema' });
// export function createCustomBlockSchema<
//     TSchema extends z.ZodObject<{
//         kind: z.ZodLiteral<'custom'>;
//         custom: z.ZodObject<{
//             type: z.ZodString;
//             data: z.ZodRecord<z.ZodString, z.ZodAny>;
//         }>;
//     }>,
// >(schema: TSchema) {
//     return z
//         .discriminatedUnion(
//             'kind',
//             [
//                 BlockUnknownSchema,
//                 BlockSelectSchema,
//                 BlockTextSchema,
//                 BlockSectionSchema,
//                 BlockActionSchema,
//                 BlockEventSchema,
//                 schema,
//             ],
//             { description: 'a block schema' }
//         )
//         .openapi('Block');
// }
exports.BlockListSchema = zod_1.z.array(exports.AnyBlockSchema).openapi('BlockList');
exports.OpenAIBlockListSchema = zod_1.z.array(exports.AnyOpenAIBlockSchema);
//# sourceMappingURL=blockSchema.js.map